import { NotifyHelper } from "../../../helpers/toast";
import { objLoaiSucKhoeDefine } from "../../action-types/danh-muc/ILoaiSucKhoeActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const loaiSucKhoeActions = {
    ...generateActions(objLoaiSucKhoeDefine, "LOAI_SUC_KHOE"),
    ...generateActionForKey(objLoaiSucKhoeDefine, "LOAI_SUC_KHOE",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objLoaiSucKhoeDefine, "LOAI_SUC_KHOE",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objLoaiSucKhoeDefine, "LOAI_SUC_KHOE",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objLoaiSucKhoeDefine, "LOAI_SUC_KHOE",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objLoaiSucKhoeDefine, "LOAI_SUC_KHOE",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
